// @ts-expect-error has no types is a polyfill
import ho from "object.hasown"

export const hasOwn = ho
